import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/data矢量.png';
const _withScopeId = n => (_pushScopeId("data-v-5bdf1980"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  style: {
    "width": "40px",
    "height": "40px",
    "margin-left": "-10px"
  }
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("h3", null, "管理系统")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 首页 ", -1));
import { ref, onMounted, computed } from 'vue';
import store from '@/store';
import { useRoute } from 'vue-router';
import SvgIcon from '@/components/SvgIcon/index.vue';
export default {
  __name: 'MyMenu',
  props: ['isClose'],
  setup(__props) {
    const props = __props;
    const route = useRoute();
    const menuList = ref(null);
    onMounted(() => {
      const menuData = sessionStorage.getItem('menuList');
      if (menuData) {
        try {
          menuList.value = JSON.parse(menuData);
        } catch (e) {
          console.error('Failed to parse menuList:', e);
          menuList.value = [];
        }
      } else {
        menuList.value = [];
      }
    });
    function getIconComponent(iconName) {
      if (iconName?.startsWith('icon-')) {
        return iconName;
      }
      return iconName ? `icon-${iconName.toLowerCase()}` : '';
    }
    const filteredThirdItems = children => {
      if (!children) return [];
      return children.filter(item => item && item.menu_type === 'C');
    };
    const openTab = item => {
      if (!item.path) return;
      let absolutePath = item.path;
      if (!absolutePath.startsWith('/')) {
        absolutePath = `/${absolutePath}`;
      }
      while (absolutePath.includes("//")) {
        absolutePath = absolutePath.replace("//", "/");
      }
      store.commit('ADD_TABS', {
        name: item.name,
        path: absolutePath,
        icon: item.icon
      });
    };
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createBlock(_component_el_menu, {
        "default-active": _unref(route).path,
        class: "el-menu-vertical-demo",
        collapse: __props.isClose,
        "background-color": "#112f50",
        "text-color": "#E0E0E0",
        "active-text-color": "#ffd04b",
        router: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, null, {
          title: _withCtx(() => [_hoisted_2]),
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/",
          onClick: _cache[0] || (_cache[0] = $event => openTab({
            name: '首页',
            path: '/'
          }))
        }, {
          default: _withCtx(() => [_createVNode(SvgIcon, {
            iconName: "icon-shouye1"
          }), _hoisted_3]),
          _: 1
        }), menuList.value && menuList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(menuList.value, menu => {
          return _openBlock(), _createBlock(_component_el_sub_menu, {
            index: menu.path || '',
            key: menu.path || menu.id
          }, {
            title: _withCtx(() => [_createVNode(SvgIcon, {
              iconName: getIconComponent(menu.icon)
            }, null, 8, ["iconName"]), _createElementVNode("span", null, _toDisplayString(menu.name), 1)]),
            default: _withCtx(() => [menu.children && menu.children.length ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 0
            }, _renderList(menu.children, item => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: item.path || item.id
              }, [item && item.menu_type ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [item.menu_type === 'M' ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 0,
                index: item.id.toString()
              }, {
                title: _withCtx(() => [_createVNode(SvgIcon, {
                  iconName: getIconComponent(item.icon)
                }, null, 8, ["iconName"]), _createElementVNode("span", null, _toDisplayString(item.name), 1)]),
                default: _withCtx(() => [item.children && item.children.length ? (_openBlock(true), _createElementBlock(_Fragment, {
                  key: 0
                }, _renderList(item.children, subItem => {
                  return _openBlock(), _createElementBlock(_Fragment, {
                    key: subItem.path || subItem.id
                  }, [subItem.children?.length && subItem.menu_type === 'M' ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 0,
                    index: subItem.id.toString()
                  }, {
                    title: _withCtx(() => [_createVNode(SvgIcon, {
                      iconName: getIconComponent(subItem.icon)
                    }, null, 8, ["iconName"]), _createElementVNode("span", null, _toDisplayString(subItem.name), 1)]),
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredThirdItems(subItem.children), thirdItem => {
                      return _openBlock(), _createBlock(_component_el_menu_item, {
                        key: thirdItem.path || thirdItem.id,
                        index: thirdItem.path,
                        onClick: $event => openTab(thirdItem)
                      }, {
                        default: _withCtx(() => [_createVNode(SvgIcon, {
                          iconName: getIconComponent(thirdItem.icon)
                        }, null, 8, ["iconName"]), _createElementVNode("span", null, _toDisplayString(thirdItem.name), 1)]),
                        _: 2
                      }, 1032, ["index", "onClick"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["index"])) : subItem.menu_type === 'C' ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 1,
                    index: subItem.path,
                    onClick: $event => openTab(subItem)
                  }, {
                    default: _withCtx(() => [_createVNode(SvgIcon, {
                      iconName: getIconComponent(subItem.icon)
                    }, null, 8, ["iconName"]), _createElementVNode("span", null, _toDisplayString(subItem.name), 1)]),
                    _: 2
                  }, 1032, ["index", "onClick"])) : _createCommentVNode("", true)], 64);
                }), 128)) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["index"])) : item.menu_type === 'C' && item.path ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1,
                index: item.path,
                onClick: $event => openTab(item)
              }, {
                default: _withCtx(() => [_createVNode(SvgIcon, {
                  iconName: getIconComponent(item.icon)
                }, null, 8, ["iconName"]), _createElementVNode("span", null, _toDisplayString(item.name), 1)]),
                _: 2
              }, 1032, ["index", "onClick"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64);
            }), 128)) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["index"]);
        }), 128)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["default-active", "collapse"]);
    };
  }
};